import BaseApi from '@/services/api/base.api'

class CategoryApi extends BaseApi {
  async selectCategoryList(): Promise<ICategoryListSelect.Response> {
    return this.app.$fetchService.get(
      `${this.artistAggregatorBaseUrl}/api/v1/entry-artist/management-category-tree`,
    )
  }

  async selectCategoryApplyPermission(): Promise<ICategoryApplyPermissionSelect.Response> {
    return this.app.$fetchService.get(
      `${this.artistAggregatorBaseUrl}/api/v1/regulated-category`,
    )
  }
}

export default CategoryApi
